module.exports = __webpack_public_path__ + "img/151.8a97cad9.jpg";